import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Tab, Table, Tabs } from "react-bootstrap";
import { FaPlus, FaTrash } from "react-icons/fa";
import AvailableResource from "./AvailableResource";

const ResourcesAsig = ({
  resources,
  show,
  gantt,
  taskEdit,
  setShow,
  newTask,
  setAssignmentResources,
  loadResources,
  setModalSize,
  hasLb,
  userRol
}) => {
  const [assignments, setAssignments] = useState([]);
  const [selectedResource, setSelectedResource] = useState("");
  const [task, setTask] = useState(taskEdit);
  const [key, setKey] = useState("asignar");
  const addAssignment = () => {
    if (!selectedResource) return;

    let existing;
    if (assignments.length > 0) {
      existing = assignments.find((a) => a.resource_id === selectedResource);
    }

    if (existing) return;

    const resource = resources.find((r) => r.id === selectedResource);
    setAssignments([
      ...assignments,
      {
        resource_id: resource.id,
        text: resource.text,
        planned_hours: 0,
        actual_hours: 0,
      },
    ]);

    setSelectedResource("");
  };

  const updateAssignment = (index, field, value) => {
    const newAssignments = [...assignments];
    newAssignments[index][field] = value;
    setAssignments(newAssignments);
  };

  const removeAssignment = (index) => {
    setAssignments(assignments.filter((_, i) => i !== index));
  };

  const resourcesAssignment = () => {
    let hoursAsig = gantt.serverList("asigHours");
    let resourcesthisTask = gantt.getTask(taskEdit.IdActividad)?.owner_id_2;

    let oneTaskInfoHour = hoursAsig?.filter((it) => {
      return it.IdActividad == taskEdit.IdActividad;
    });

    let ownerHourTask = resourcesthisTask?.map((it) => {
      return {
        resource_id: it.resource_id,
        planned_hours: it.planned_hours || 0,
        actual_hours: it.actual_hours || 0,
        text: resources.filter((re) => re.id == it.resource_id)[0].text,

      };
    });

    setAssignments(ownerHourTask);
    setAssignmentResources(ownerHourTask);
  };

  useEffect(() => {
    if (show) {
      if (taskEdit.IdActividad) {
        resourcesAssignment();
      }
    }
  }, [show]);


  const handleAssignment = (assignments_to_save) => {
    if (Object.keys(newTask).length) {
      setAssignmentResources(assignments_to_save);
      setShow(false);
    } else if (Object.keys(taskEdit).length) {
      setAssignmentResources(assignments_to_save);
      setShow(false);
    }
  };

  useEffect(() => {
    if (key == "asignar") {
      setModalSize("lg");
    } else {
      setModalSize("xl");
    }
  }, [key]);

  return (
    <>
      <Tabs className="mb-3" onSelect={(k) => setKey(k)} accessKey={key}>
        <Tab eventKey="asignar" title="🛠 Asignar Recursos">
          <Form.Group controlId="resourceSelect">
            <Form.Label className="fw-bold text-muted">
              Seleccionar Recurso
            </Form.Label>
            <div className="d-flex align-items-center">
              <Form.Select
                value={selectedResource}
                onChange={(e) => setSelectedResource(e.target.value)}
                className="mr-2 shadow-sm form-control"
                style={{
                  maxWidth: "250px",
                  minWidth: "150px",
                  borderRadius: "2px",
                }}
              >
                <option value="">-- Seleccionar --</option>
                {resources?.map((res) => (
                  <option key={res.id} value={res.id}>
                    {res.text}
                  </option>
                ))}
              </Form.Select>
              <Button
                variant="danger"
                onClick={addAssignment}
                className="ml-2 shadow-sm d-flex align-items-center justify-content-center"
                style={{
                  width: "38px",
                  height: "38px",
                  borderRadius: "10%",
                  backgroundColor: "#DB5E18",
                  border: "none",
                }}
              >
                <FaPlus size={16} />
              </Button>
            </div>
          </Form.Group>

          {assignments?.length > 0 && (
            <div style={{ maxHeight: "300px", overflow: "hidden scroll" }}>
              <Table striped hover size="sm" className="mt-3 table-borderless">
                <thead>
                  <tr className="text-muted fw-bold">
                    <th>Recurso</th>
                    <th style={{ width: "150px" }}>Horas Planeadas</th>
                    <th style={{ width: "150px" }}>Horas Reales</th>
                    <th className="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {assignments?.map((assignment, index) => (
                    <tr key={assignment.resource_id}>
                      <td className="align-middle">{assignment.text}</td>
                      <td>
                        <Form.Control
                          type="number"
                          min="0"
                          className="text-center shadow-sm"
                          style={{ borderRadius: "6px", maxWidth: "120px" }}
                          value={assignment.planned_hours}
                          disabled={hasLb? true :false}
                          onChange={(e) =>
                            updateAssignment(
                              index,
                              "planned_hours",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          min="0"
                          className="text-center shadow-sm"
                          style={{ borderRadius: "6px", maxWidth: "120px" }}
                          value={assignment.actual_hours}
                          onChange={(e) =>
                            updateAssignment(
                              index,
                              "actual_hours",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td className="text-center d-flex justify-content-center">
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="d-flex align-items-center justify-content-center"
                          disabled = {userRol == "Miembro de Equipo" ? true : false}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                          }}
                          onClick={() => removeAssignment(index)}
                        >
                          <FaTrash size={14} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
          <hr />
          <div className="d-flex justify-content-end">
            <Button
              variant="success"
              onClick={() => handleAssignment(assignments)}
            >
              Asignar
            </Button>
          </div>
        </Tab>
        <Tab eventKey="buscar" title="🔍 Disponibilidad Recursos">
          <AvailableResource resources={resources} />
        </Tab>
      </Tabs>
    </>
  );
};

export default ResourcesAsig;
